module.exports = __webpack_public_path__ + "img/pin-bronze.8a20b454.png";